
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { getControlId, getCampaignDashboardErrors, getCampaignDashboardInstanceSettings, getApiPollingTimeInterval } from '../selectors';
import { DashboardDataApi } from '../requests';
import { actions as dashboardActions } from 'dashboards';
import { network } from '@imodules/helix';

const { populateDashboardData } = dashboardActions;

export const initiateCampaignDashboardPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getCampaignDashboardErrors(state) < 5) {
            const request = dispatch(pollCampaignDashboard());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollCampaignDashboard = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const settings = getCampaignDashboardInstanceSettings(state);
        const controlId = getControlId(state);

        if (settings) {
            try {
                dispatch(await makeDashboardRequest(controlId));
                dispatch(actions.apiCallSuccess());
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
        }
    };
};

export const makeDashboardRequest = (controlId: number): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = DashboardDataApi.createGetRequest(controlId);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(populateDashboardData(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const watchCampaignDashboardData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateCampaignDashboardPolling());
    };
};